import React from 'react';
import { Formik, Form, Field } from 'formik';
import TitleMain from "../Title/TitleMain";
import {resetPassword, setNewPassword} from "../../services/AuthService";
import styles from "./LoginForm.module.css";
import FieldCustom from "../Field/FieldCustom";
import FieldPassword from "../Field/FieldPassword";
import {useNavigate, useParams} from "react-router-dom";
import {validateEmail} from "../../services/UserService";
import {useModal} from "../../contexts/ModalContext";
import Routing from "../../services/routing";


const validatePassword = (value) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!value) {
        return "Le mot de passe est requis.";
    }
    if (!passwordRegex.test(value)) {
        return "Le mot de passe doit contenir au moins 8 caractères, une minuscule, une majuscule et un chiffre.";
    }
    return null;
};

function PasswordNewForm() {
    const { mail} = useParams();
    const { token } = useParams();
    const { showModal, hideModal } = useModal();
    const navigate = useNavigate();
    const [error, setError] = React.useState(null);

    const handleSuccess = (children = "Succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const onSubmit = async (values, { setSubmitting }) => {
        if(!validateEmail(mail)) {
            handleError('Erreur mail non valide');
            return;
        }

        if (validatePassword(values.password) !== null) {
            handleError('Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre.');
            setError('Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre.');
            return;
        }

        try {
            const response = await setNewPassword(values, token, mail);
            if (response.success === true) {
                handleSuccess(response.message);
                setTimeout(() => {
                    navigate(Routing.routes.login, { state: { email: mail } });
                }, 1500);
            } else {
                if (response.message) {
                    handleError(response.message);
                    setError(response.message);
                } else if (response.error) {
                    handleError(response.error);
                    setError(response.message);
                } else {
                    handleError("Ce mot de passe n'est pas valide");
                    setError("Ce mot de passe n'est pas valide");
                }
            }
        } catch (error) {
            handleError('Erreur lors de la réinitialisation du mot de passe:' + error);
        }
        setSubmitting(false);
    }

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        const error = validatePassword(value);
        console.error("Erreur de validation de mot de passe :", error);
    };

    return (
        <Formik
            initialValues={{ password: '' }} onSubmit={onSubmit}>
            {({ isSubmitting }) => (
                <Form className={styles.form}>
                    <div>
                        <TitleMain text="NOUVEAU MOT DE PASSE" />
                        <FieldPassword/>
                        {error && <div className="error" style={{
                            backgroundColor: "var(--clr-error)",
                            color: "var(--clr-font-main)",
                            fontSize: "var(--fs-secondary)",
                            marginTop: "8px",
                            padding: "8px",
                            borderRadius: "16px",
                        }}>{error}</div>}
                    </div>


                    <button type="submit" className={`btn ${styles.btn}`} disabled={isSubmitting}>
                        Enregistrer le mot de passe
                    </button>
                </Form>
            )}
        </Formik>
    );
}

export default PasswordNewForm;
